import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../../../styles/Auth/profile.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { getData, putData } from '../../../webService/webservice.js'
const ChangepasswordPage = () => {
    const navigate = useNavigate();
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [formData, setFormData] = useState(
        {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
        }
    );

    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        setPasswordMatchError(""); // Clear previous errors
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");
            if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
                setPasswordMatchError("All fields are required");
                return;
            }
            if (formData.newPassword !== formData.confirmPassword) {
                setPasswordMatchError("New password and confirm password do not match");
                return;
            }
            const payload = {
                currentPassword: formData.currentPassword,
                password: formData.newPassword,
            };

            const response = await putData(`users/user/${userId}`, payload, token);

            toast.success(response.message || 'Password updated successfully');

            // Reset form and navigate
            setFormData({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
            });
            navigate('/dashboard');
        } catch (err) {
            console.error("Error updating password:", err);
            toast.error(err.response?.data?.message || "Failed to update password");
        }
    };

    return (

        <>
            <div className="profile-layout">
                <div className="profile-content">
                    <main className="profile-main">
                        <div className="update-profile-form">
                            <h3>Change Password</h3>
                            <form className='profile-form' onSubmit={handleUpdateProfile}>
                                <div className='profile-form-row'>
                                    <div className="profile-form-group">
                                        <label htmlFor="currentPassword" className="input-label">
                                            Current Password
                                        </label>
                                        <div className="password-input-container">
                                            <input
                                                type={showCurrentPassword ? "text" : "password"}
                                                id="currentPassword"
                                                className="profile-input"
                                                placeholder="Enter Current Password"
                                                autoComplete="current-password"
                                                value={formData.currentPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, currentPassword: e.target.value }))
                                                }
                                            />
                                            <span
                                                className="signup-show"
                                                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                            >
                                                {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='profile-form-group'>
                                        <label htmlFor="newPassword" className="input-label">
                                            New Password
                                        </label>
                                        <div className='password-input-container'>
                                            <input
                                                type={showNewPassword ? "text" : "password"}
                                                id="newPassword"
                                                className="profile-input"
                                                placeholder="Enter New Password"
                                                autoComplete="new-password"
                                                value={formData.newPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, newPassword: e.target.value }))
                                                }
                                            />
                                            <span
                                                className="signup-show"
                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                            >
                                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-form-group">
                                        <label htmlFor="confirmPassword" className="input-label">Confirm Password</label>
                                        <div className='password-input-container'>
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                id="confirmPassword"
                                                className="profile-input"
                                                placeholder="Confirm New Password"
                                                autoComplete="new-password"
                                                value={formData.confirmPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, confirmPassword: e.target.value }))
                                                }
                                            />
                                            <span className="signup-show" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {passwordMatchError && <p className="password-error-text" style={{ color: "red", marginTop: "10px" }}>{passwordMatchError}</p>}

                                <div className="Profile-buttons">
                                    <button className="add-Product-button" type="submit">
                                        Save Changes
                                    </button>
                                    <button className="cancel-Product-button" type="button" onClick={() => navigate('/dashboard')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </main>
                </div >
            </div >
        </>
    );
};

export default ChangepasswordPage;